<template>
  <div>
    <div id="show-overlay"></div>
    <Loader />
    <div class="wrapper">
      <!-- Sidebar  -->
      <SideBarStyle1
        :items="verticalMenu"
        :horizontal="horizontal"
        :logo="logo"
        @toggle="sidebarMini"
      />
      <div
        id="content-page"
        class="content-page"
        :class="horizontal ? 'ml-0' : ''"
      >
        <!-- TOP Nav Bar -->
        <NavBarStyle1
          title="Dashboard"
          :homeURL="{ name: 'dashboard.home-1' }"
          @toggle="sidebarMini"
          :logo="logo"
          :horizontal="horizontal"
          :items="horizontalMenu"
        >
          <template v-slot:responsiveRight v-if="doctor">
            <ul class="navbar-nav ml-auto navbar-list">
              <!-- <li class="nav-item iq-full-screen">
                <a href="#" class="iq-waves-effect" id="btnFullscreen"
                  ><i class="ri-fullscreen-line"></i
                ></a>
              </li> -->
              <li class="nav-item">
                <a href="#" class="search-toggle iq-waves-effect">
                  <i class="ri-notification-3-fill"></i>
                  <span
                    v-if="notification.length"
                    class="bg-danger dots"
                  ></span>
                </a>
                <div class="iq-sub-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0">
                      <div class="bg-primary p-3">
                        <h5 class="mb-0 text-white">
                          {{ TopNav.allNotifications
                          }}<small class="badge badge-light float-right pt-1">{{
                            notification.length
                          }}</small>
                        </h5>
                      </div>
                      <div v-if="!notification.length" class="iq-sub-card">
                          You have no notifications.
                      </div>
                      <a
                        href="#"
                        @click="notificationPressed(item)"
                        class="iq-sub-card"
                        v-for="(item, index) in notification"
                        :key="index"
                      >
                        <div class="media align-items-center">
                          <div class="">
                            <img
                              class="avatar-40 rounded"
                              :src="item.image"
                              alt="img"
                            />
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">{{ item.name }}</h6>
                            <small class="float-right font-size-12">{{
                              item.date
                            }}</small>
                            <p class="mb-0">
                              {{ item.description.substring(0, 40) + "..." }}
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item" ref="messageDropdown">
                <a href="#" class="search-toggle iq-waves-effect">
                  <i class="ri-mail-open-fill"></i>
                  <span
                    v-if="message.length"
                    class="bg-primary count-mail"
                  ></span>
                </a>
                <div class="iq-sub-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0">
                      <div class="bg-primary p-3">
                        <h5 class="mb-0 text-white">
                          {{ TopNav.allMessages
                          }}<small class="badge badge-light float-right pt-1">{{
                            message.length
                          }}</small>
                        </h5>
                      </div>
                      <div v-if="!message.length" class="iq-sub-card">
                          You have no messages.
                      </div>
                      <a
                        href="#"
                        class="iq-sub-card"
                        v-for="(item, index) in message"
                        :key="index"
                      >
                        <div
                          @click="messageClicked"
                          class="media align-items-center"
                        >
                          <div class="">
                            <img
                              class="avatar-40 rounded"
                              :src="item.image"
                              alt="img"
                            />
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">{{ item.name }}</h6>
                            <small class="float-left font-size-12">{{
                              item.date
                            }}</small>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item" v-if="!loadingUserStatus && isUserPatient && patient.isAuthroized" ref="cartPreview">
                <a href="#" class="search-toggle iq-waves-effect">
                  <i class="ri-shopping-cart-2-fill"></i>
                  <span
                    v-if="shoppingCart && shoppingCart.length"
                    class="cart-badge"
                  >{{ totalQuantity }}</span>
                </a>
                <div class="iq-sub-dropdown cartDropDown">
                  <div class="iq-card shadow-none m-0 cartDropDown">
                    <div class="iq-card-body p-0">
                      <div class="bg-primary p-3">
                        <h5 class="mb-0 text-white">
                          {{ TopNav.allCarts
                          }}
                          <small class="badge badge-light float-right pt-1">{{
                            totalQuantity
                          }}</small>
                        </h5>
                      </div>
                      <div v-if="shoppingCart && !shoppingCart.length" class="iq-sub-card">
                          Your shopping cart is empty.
                      </div>
                      <div v-show="shoppingCart.length">
                        <CartItems @cartPreviewShouldClose="closeCartPreview"></CartItems>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </template>
          <template v-slot:right v-if="doctor">
            <ul class="navbar-list">
              <li ref="dropDown">
                <a
                  href="#"
                  class="search-toggle iq-waves-effect d-flex align-items-center"
                >
                  <img
                    v-if="doctor.profilePic"
                    :src="doctor.profilePic"
                    class="img-fluid rounded mr-3"
                    alt="user"
                  />
                  <img
                    v-else-if="patient && patient.profilePic"
                    :src="patient.profilePic"
                    class="img-fluid rounded mr-3"
                    alt="user"
                  />
                  <img
                    v-else
                    :src="defaultProfilePic"
                    class="img-fluid rounded mr-3"
                    alt="user"
                  />
                  <div class="caption" v-if="patient">
                    <h6 v-if="!loadingUserStatus && isUserPatient && patient" class="name mb-0 line-height">{{ patient.firstName }} {{ patient.lastName }}</h6>
                    <h6 v-if="!loadingUserStatus && isUserDoctor && doctor" class="name mb-0 line-height">{{ doctor.firstName }} {{ doctor.lastName }}</h6>
                    <h6 v-if="!loadingUserStatus && isUserAdmin && admin" class="name mb-0 line-height">{{ admin.firstName }} {{ admin.lastName }}</h6>
                    <span class="font-size-12 accent-text">{{
                      TopNav.user.available
                    }}</span>
                  </div>
                </a>
                <div class="iq-sub-dropdown iq-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0">
                      <div class="bg-primary p-3">
                        <h5 v-if="!loadingUserStatus && isUserPatient && patient" class="mb-0 text-white line-height">
                          Hello {{ patient.firstName }} {{ patient.lastName }}
                        </h5>
                        <h5 v-if="!loadingUserStatus && isUserDoctor && doctor" class="mb-0 text-white line-height">
                          Hello {{ doctor.firstName }} {{ doctor.lastName }}
                        </h5>
                        <h5 v-if="!loadingUserStatus && isUserAdmin && admin" class="mb-0 text-white line-height">
                          Hello {{ admin.firstName }} {{ admin.lastName }}
                        </h5>
                        <span class="text-white font-size-12 accent-text">{{
                          TopNav.user.available
                        }}</span>
                      </div>
                      <a
                        href="#"
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                      <div
                        @click="goProfile"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-file-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">{{ TopNav.user.profileTitle }}</h6>
                            <p class="mb-0 font-size-12">
                              {{ TopNav.user.profileSub }}
                            </p>
                          </div>
                        </div>
                      </div>
                      </a>
                      <a
                        href="#"
                        class="iq-sub-card iq-bg-primary-success-hover"
                      >
                      <div
                        @click="goEditProfile"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-success">
                            <i class="ri-profile-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">
                              {{ TopNav.user.profileEditTitle }}
                            </h6>
                            <p class="mb-0 font-size-12">
                              {{ TopNav.user.profileEditSub }}
                            </p>
                          </div>
                        </div>
                      </div>
                      </a>
                      <div v-if="isUserPatient && patient.isAuthroized"
                        class="iq-sub-card iq-bg-primary-hover"
                        @click="goOrderHistory"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-primary">
                            <i class="ri-store-3-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">
                              {{ TopNav.patient.ordersTitle }}
                            </h6>
                            <p class="mb-0 font-size-12">
                              {{ TopNav.patient.ordereSub }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <a
                        href="#"
                        class="iq-sub-card iq-bg-primary-secondary-hover"
                      >
                        <div   @click="goSettings" class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-secondary">
                            <i class="ri-account-box-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">
                              {{ TopNav.user.accountSettingTitle }}
                            </h6>
                            <p class="mb-0 font-size-12">
                              {{ TopNav.user.accountSettingSub }}
                            </p>
                          </div>
                        </div>
                      </a>
                      <!-- <a
                        href="#"
                        class="iq-sub-card iq-bg-primary-secondary-hover"
                      >
                        <div class="media align-items-center">
                          <div class="rounded iq-card-icon iq-bg-secondary">
                            <i class="ri-lock-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">
                              {{ TopNav.user.privacySettingTitle }}
                            </h6>
                            <p class="mb-0 font-size-12">
                              {{ TopNav.user.privacySettingSub }}
                            </p>
                          </div>
                        </div>
                      </a> -->
                      <div class="d-inline-block w-100 text-center p-3">
                        <a
                          class="iq-bg-danger iq-sign-btn"
                          href="javascript:void(0)"
                          @click="logout"
                          role="button"
                          >{{ TopNav.user.signout
                          }}<i class="ri-login-box-line ml-2"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </template>
        </NavBarStyle1>
        <!-- TOP Nav Bar END -->
        <router-view v-slot="{ Component }">
          <transition
            name="router-anim"
            :enter-active-class="`animated ${animated.enter}`"
            mode="out-in"
            :leave-active-class="`animated ${animated.exit}`"
          >
            <component :is="Component" />
          </transition>
        </router-view>
        <FooterStyle1>
          <template v-slot:left>
            <li class="list-inline-item"><a href="#">Privacy Policy</a></li>
            <li class="list-inline-item"><a href="#">Terms of Use</a></li>
          </template>
          <template v-slot:right>
            Copyright 2024 <a href="#">Texavie</a> All Rights Reserved.
          </template>
        </FooterStyle1>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../components/xray/loader/Loader'
import SideBarStyle1 from '../components/xray/sidebars/SideBarStyle1'
import NavBarStyle1 from '../components/xray/navbars/NavBarStyle1'
import SideBarItems from '../FackApi/json/SideBar.json'
import PatientSideBarItems from '../FackApi/json/PatientHomeSideBar'
import PatientUnauthorizedSideBar from '../FackApi/json/PatientUnauthorizedSideBar'
import AdminSideBarItems from '../FackApi/json/AdminHomeSideBar' 
import HorizontalItems from '../FackApi/json/HorizontalMenu'
import profile from '../assets/images/user/1.jpg'
import loader from '../assets/images/logo.png'
import { xray } from '../config/pluginInit'
import { Users } from '../FackApi/api/chat'
import { useStore } from 'vuex'
import TopNav from '../FackApi/json/TopNav.json'
import firebaseService from '../../firebase'
import { useRouter } from 'vue-router'
import getDocument from '../services/getDocument'
import getCollection from '../services/getCollection'
import { onMounted, watch, ref, computed } from 'vue'
import { documents } from '../store/store'
import CartItems from '../components/CartItems.vue'
import {
  collection,
  doc,
  getDoc,
  query,
  updateDoc,
  where
} from '@firebase/firestore'

export default {
  name: 'Layout1',
  components: {
    Loader,
    SideBarStyle1,
    NavBarStyle1,
    CartItems
  },
  mounted () {
    const currentUser = firebaseService.firebaseAuth.currentUser
    this.displayName = currentUser.displayName
    // const query2 = query(
    //   collection(firebaseService.db, "emails"),
    //   where("to", "==", currentUser.email),
    //   where("is_unread", "==", true)
    // );
    // const { err, documents: emails } = getCollection("emails", query2);
    const q = query(
      collection(firebaseService.db, 'reminders'),
      where('isRead', '==', false),
      where('doctorID', '==', currentUser.uid)
    )
    const { documents: reminders } = getCollection('reminders', q)
    this.updateEmailNotifications()
    watch(documents, () => {
      this.updateEmailNotifications()
    })

    watch(reminders, async () => {
      const filtered = reminders.value.filter(
        (doc) =>
          doc.doctorID === firebaseService.firebaseAuth.currentUser.uid &&
          !doc.isRead
      )
      this.notification = []
      const promiseArray = []
      for (const document of filtered) {
        const docRef = doc(
          firebaseService.db,
          'appointments',
          document.appointmentID
        )
        const docSnapshot = getDoc(docRef)
        promiseArray.push(docSnapshot)
      }
      const appointments = await Promise.all(promiseArray)

      const today = new Date()
      for (const docSnapshot of appointments) {
        const data = docSnapshot.data()
        const apptDate = data.datetime.toDate()
        if (today.setHours(0, 0, 0, 0) != apptDate.setHours(0, 0, 0, 0)) {
          continue
        }
        let location
        if (data.isOnline) {
          location = 'Online'
        } else {
          location = data.location
        }
        this.notification.push({
          image: require('../assets/images/user/01.jpg'),
          name: `Appointment at ${data.datetime.toDate().toLocaleString()}`,
          date: '',
          description: `Location: ${location}`,
          reminderID: docSnapshot.id
        })
      }
    })
    this.updateRadio()
  },
  computed: {
    // ...mapGetters({
    //   langsOptions: 'Setting/langOptionState',
    //   colors: 'Setting/colorState'
    // })
  },
  // sidebarTicket
  data () {
    return {
      horizontal: false,
      mini: false,
      darkMode: false,
      animated: { enter: 'zoomIn', exit: 'zoomOut' },
      animateClass: [
        { value: { enter: 'zoomIn', exit: 'zoomOut' }, text: 'Zoom' },
        { value: { enter: 'fadeInUp', exit: 'fadeOutDown' }, text: 'Fade' },
        {
          value: { enter: 'slideInLeft', exit: 'slideOutRight' },
          text: 'Slide'
        },
        {
          value: { enter: 'rotateInDownLeft', exit: 'rotateOutDownLeft' },
          text: 'Roll'
        }
      ],
      horizontalMenu: HorizontalItems,
      userProfile: profile,
      logo: loader,
      usersList: Users,
      rtl: false,
      message: [],
      notification: [],
      displayName: ''
    }
  },
  methods: {
    async notificationPressed (item) {
      await updateDoc(doc(firebaseService.db, 'reminders', item.reminderID), {
        isRead: true
      })
    },
    updateRadio () {
      this.horizontal = this.$store.getters['Setting/horizontalMenuState']
      this.mini = this.$store.getters['Setting/miniSidebarState']
    },
    sidebarHorizontal () {
      this.$store.dispatch('Setting/horizontalMenuAction')
      this.updateRadio()
    },
    sidebarMini () {
      xray.triggerSet()
      this.$store.dispatch('Setting/miniSidebarAction')
      this.updateRadio()
    },
    rtlChange () {
      if (this.rtl) {
        this.rtlRemove()
      } else {
        this.rtlAdd()
      }
    },
    changeColor (code) {
      document.documentElement.style.setProperty('--iq-primary', code.primary)
      document.documentElement.style.setProperty(
        '--iq-primary-light',
        code.primaryLight
      )
      if (this.darkMode) {
        document.documentElement.style.setProperty(
          '--iq-bg-dark-color',
          code.bodyBgDark
        )
      } else {
        document.documentElement.style.setProperty(
          '--iq-bg-light-color',
          code.bodyBgLight
        )
      }
    },
    reset () {
      this.changeColor({
        primary: '#827af3',
        primaryLight: '#b47af3',
        bodyBgLight: '#efeefd',
        bodyBgDark: '#1d203f'
      })
      this.animated = { enter: 'zoomIn', exit: 'zoomOut' }
      this.light()
    },
    logout () {
      // localStorage.removeItem('user')
      // localStorage.removeItem('access_token')
      firebaseService.firebaseAuth.signOut()
      this.$router.push({ name: 'auth1.sign-in1' })
    },
    // ...mapActions({
    //   rtlAdd: 'Setting/setRtlAction',
    //   rtlRemove: 'Setting/removeRtlAction'
    // }),
    updateEmailNotifications () {
      this.message = []
      for (const email of documents) {
        if (!email.delivery || email.is_unread === false) continue
        const name = email.message.subject
        const date = email.delivery.startTime.toDate().toLocaleString()
        this.message.push({
          image: require('../assets/images/user/01.jpg'),
          name: name,
          date: date
        })
      }
    }
  },
  setup () {
    const router = useRouter()
    const dropDown = ref(null)
    const defaultProfilePic = require('../assets/images/user/1.jpg')
    const firebaseUser = firebaseService.firebaseAuth.currentUser
    const { document: doctor } = getDocument('doctors', firebaseUser.uid)
    const { document: patient } = getDocument('users', firebaseUser.uid)
    const { document: admin } = getDocument('admin', firebaseUser.uid)

    const messageDropdown = ref(null)

    const goProfile = () => {
      dropDown.value.classList.remove('iq-show')
      if (isUserPatient.value) {
        router.push({ name: 'patient.patientProfile' })
      } else {
        router.push({ name: 'dashboard.profile' })
      }
    }

    const goEditProfile = () => {
      dropDown.value.classList.remove('iq-show')

      if (isUserPatient.value) {
        router.push({ name: 'patient.patientProfileEdit' })
      } else {
        router.push({ name: 'dashboard.editProfile' })
      }
    }

    const goSettings = () => {
      dropDown.value.classList.remove('iq-show')
      router.push({ name: 'dashboard.settings' })
    }

    const messageClicked = () => {
      messageDropdown.value.classList.remove('iq-show')
      router.push('/app/email')
    }

    const verticalMenu = ref(null)
    const loadingUserStatus = ref(true)
    const isUserPatient = ref(false)
    const isUserDoctor = ref(false)
    const isUserAdmin = ref(false)

    onMounted(async () => {
      const ref = doc(firebaseService.db, 'doctors', firebaseUser.uid)
      const patientsRef = doc(firebaseService.db, 'users', firebaseUser.uid)

      const docSnapshot = await getDoc(ref)
      if (docSnapshot.exists()) {
        verticalMenu.value = SideBarItems
        isUserDoctor.value = true
      } else {
        const patientSnapshot = await getDoc(patientsRef)
        if (patientSnapshot.exists()) {
          verticalMenu.value = patientSnapshot.data().isAuthorized
            ? PatientSideBarItems
            : PatientUnauthorizedSideBar
          isUserPatient.value = true
        } else {
          verticalMenu.value = AdminSideBarItems
          isUserAdmin.value = true
        }
      }
      loadingUserStatus.value = false
    })
    const store = useStore()
    const shoppingCart = computed(() => store.getters['shoppingCart/cartProducts'])
    const total = computed(() => store.getters['shoppingCart/cartTotalPrice'])
    const totalQuantity = computed(() => store.getters['shoppingCart/cartTotalQuantity'])

    const closeCartPreview = () => {
      cartPreview.value.classList.remove('iq-show')
    }

    const goOrderHistory = () => {
      dropDown.value.classList.remove('iq-show')
      router.push({ name: 'patient.orderHistory' })
    }

    const cartPreview = ref(null)
    return {
      TopNav,
      goProfile,
      dropDown,
      goEditProfile,
      defaultProfilePic,
      doctor,
      admin,
      verticalMenu,
      isUserPatient,
      isUserDoctor,
      isUserAdmin,
      shoppingCart,
      total,
      closeCartPreview,
      cartPreview,
      totalQuantity,
      goOrderHistory,
      messageClicked,
      messageDropdown,
      patient,
      loadingUserStatus,
      goSettings,
      firebaseUser
    }
  }
}
</script>

<style>
.cartDropDown {
  width: 450px !important;
  max-height: 600px;
  overflow-y: auto;
}

.cart-badge {
  position: absolute;
    top: 15px;
    right: 0px;
    padding: 5px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 12px;
    border-radius: 50%;
    color: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 9999px;
    font-weight: 700;
    font-size: 12px;
    color: white;
    background-color: var(--badge-color);
    width: 20px;
    height: 20px;
}

.name {
  color: var(--text-color) !important;
  font-weight: 400 !important;
}

</style>

<style>
.accent-text {
  color: var(--accent-color) !important;
} 
</style>